import {} from "./ui/dropdown-menu.js";  // to import module
import {} from "./ui/main-menu.js";  // to import module

window.$ = $;
window.jQuery = jQuery;